import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check-green-filled",
  "use": "icon-check-green-filled-usage",
  "viewBox": "0 0 23 18",
  "content": "<symbol viewBox=\"0 0 23 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check-green-filled\">\n<path d=\"M22.1 4.97332L17.7162 0L9.6189 9.90814L4.52632 3.40664L0 8.53778L9.48023 17.1449L22.1 4.97717V4.97332Z\" fill=\"#1DCA7D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol